import PrestaGlobals from "../common/PrestaGlobals";
import IParamScriptsRule from "../database/IParamScriptsRule";

class NameConfigurator
{
    public rule: IParamScriptsRule;
    private target: HTMLElement;

    constructor(rule: IParamScriptsRule)
    {
        this.rule = rule; // store rule for later use
        
        switch(this.rule.tab) {
            case "configuration": this.target = document.querySelector('div[data-id="configuration"]')!; break;
            case "material":
            case "materials": this.target = document.querySelector('div[data-id="material"]')!; break;
            default: this.target = document.querySelector('div[data-id="material"]')!; break;
        }
        const template: HTMLElement = document.querySelector<HTMLElement>('[data-id="CabinetName"]')!;
        const cloned: HTMLElement = template!.cloneNode(true) as HTMLElement;
      
        const cabinetNameInput: HTMLInputElement = cloned.querySelector<HTMLInputElement>('[data-id="cabinetNameInput"]')!;

        // overwrite name using localized productName
        if(this.rule.parameterValue === "") {
            this.rule.parameterValue = PrestaGlobals.productName;
        }
        cabinetNameInput.value = this.rule.parameterValue;

        // add event listener to cabinetNameInput
        cabinetNameInput.addEventListener("change", (event: Event) => {
            //gProductName = event.target.value;
            this.rule.parameterValue = (event.target! as HTMLInputElement).value;

            console.log("cabinet name changed:" + this.rule.parameterValue);
        });

        this.target.appendChild(cloned);
    }

    public getName(): string {
        return this.rule.parameterValue;
    }

    // find the cloned template in target and remove it
    public cleanup(): void {
        const templates: NodeListOf<HTMLElement> = this.target.querySelectorAll<HTMLElement>('[data-id="CabinetName"]');
        for(let template of templates) {
            template.remove();
        }
    }

    // TODO: create paramscript interface type
    public createParamScript(): Object {
        const res: any = {};
        res[this.rule.parameterProperty] = {
            "Path": "",
            "Name": this.rule.parameterValue
        };
        return res;
    }
}

export default NameConfigurator;
